export default {
      id: "vague_h2-usage",
      viewBox: "0 0 100 14",
      url: "../dist/images/" + "sprite.svg#vague_h2-usage",
      toString: function () {
        return this.url;
      }
    }